import { Icon } from "@iconify/react/dist/iconify.js";
import { Avatar, Button, Dropdown, Flex, Image, Menu } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AddBTN } from "../../../components/button";
import { primaryColor, thirdColor } from "../../../config";
import { fakeImage } from "../../../config/fakeData";
import { resolveMediaUrl } from "../../../utils/mediaUrl";
import { getPermissionsSignature } from "../../../utils/permissions";
import { ProfileView } from "../header/style";
import { FindMenus } from "./menus";
import { Wrapper } from "./style";

export default function Sidebar({
  collapsed,
  user,
  menuPermissions = null,
  type,
  location,
  setData,
  handleLogout,
  setCollapsed,
  isSmallScreen,
  visible,
  setVisible,
}) {
  const { i18n } = useTranslation();
  const [current, setCurrent] = useState(location?.pathname?.replace("/", ""));
  const { email, name } = user?.user?.user_data;
  const navigate = useNavigate();
  const [openKeys, setOpenKeys] = useState([]);
  const permissionsSignature = Array.isArray(menuPermissions)
    ? menuPermissions.slice().sort().join("|")
    : getPermissionsSignature(user);
  const language = i18n.language;
  const menuItems = useMemo(
    () => FindMenus(type, user, menuPermissions),
    [type, user, menuPermissions, permissionsSignature, language]
  );

  useEffect(() => {
    const currentPath = location?.pathname?.replace("/", "");

    if (currentPath === "subscription" || currentPath.startsWith("subscription/")) {
      setCurrent("subscription");
    } else if (
      currentPath === "callback-sp" ||
      currentPath === "callback-ads" ||
      currentPath === "callback-salla" ||
      currentPath === "callback-zid" ||
      currentPath === "trendyol" ||
      currentPath === "noon"
    ) {
      setCurrent("app-management");
    } else {
      setCurrent(currentPath);
    }

    const parentKeys = findParentKeys(menuItems, currentPath);
    setOpenKeys(parentKeys);
  }, [location, menuItems, permissionsSignature]);

  const findParentKeys = (items, currentPath, keys = []) => {
    for (const item of items) {
      if (item.key === currentPath) {
        return keys;
      }
      if (item.children) {
        const foundKeys = findParentKeys(item.children, currentPath, [
          ...keys,
          item.key,
        ]);
        if (foundKeys) {
          return foundKeys;
        }
      }
    }
    return null;
  };

  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  return (
    <Wrapper
      className="slideInLeft"
      width={300}
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={
        isSmallScreen
          ? {
              overflow: "auto",
              height: "100vh",
              position: "fixed",
              insetInlineStart: 0,
              top: 0,
              bottom: 0,
              display: isSmallScreen ? (visible ? "block" : "none") : "block",
              zIndex: isSmallScreen ? (visible ? 1054 : 0) : 1000,
            }
          : {}
      }
    >
      <div className="sidebar-view ">
        <Menu
          key={`${permissionsSignature || "default-menu"}-${language}`}
          className="sidebar-main-menu"
          selectedKeys={[current]}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          onClick={(e) => {
            setCurrent(e?.key);
            setVisible(false);
          }}
          theme="light"
          inlineIndent={0}
          style={{
            position: "relative",
            insetInlineEnd: "0px",
            insetInlineStart: "0px",
            overflow: "hidden",
          }}
          mode="inline"
          items={menuItems}
        />
      </div>
      {/* <Flex
        justify="space-between"
        align="start"
        gap={10}
        className="mb-5 ms-5"
        style={{ position: "absolute", bottom: 0 }}
      >
        <div>
          {user?.user?.user_data?.photo ? (
            <Avatar
              size={isSmallScreen ? 38 : 44}
              src={user?.user?.user_data?.photo ? resolveMediaUrl(user?.user?.user_data?.photo) : undefined}
            />
          ) : (
            <Avatar
              style={{
                backgroundColor: "#073b4c",
                verticalAlign: "middle",
                fontSize: isSmallScreen ? "16px" : "18px",
              }}
              size={isSmallScreen ? "default" : "large"}
            >
              {user?.user?.user_data?.name?.charAt(0).toUpperCase()}
            </Avatar>
          )}
        </div>
        <div>
          <h4 style={{ fontWeight: "700" }}>{user?.user?.user_data?.name}</h4>
          <p>{user?.user?.user_data?.email}</p>
        </div>
      </Flex> */}
    </Wrapper>
  );
}
